module.exports = __webpack_public_path__ + "static/image/company/principle_2.ver2_0_2.jpg?d8f5a331";